import { Link } from '@tanstack/react-router';

export function Footer() {
  return (
    <footer className="border-t border-border/50 bg-background/80 backdrop-blur-lg">
      <div className="container mx-auto px-4 py-6 flex flex-col md:flex-row justify-between items-center gap-4">
        <p className="text-sm text-muted-foreground">© 2026 Omokage. All rights reserved.</p>
        <nav className="flex flex-wrap gap-4 md:gap-6 text-sm">
          <Link
            to="/terms"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            利用規約
          </Link>
          <Link
            to="/privacy"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            プライバシーポリシー
          </Link>
          <Link
            to="/cookie-policy"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            Cookieポリシー
          </Link>
          <Link
            to="/copyright"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            著作権ポリシー
          </Link>
          <Link
            to="/licenses"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            OSSライセンス
          </Link>
          <a
            href="https://docs.google.com/forms/d/e/1FAIpQLSfjivMbuWYHDPj3KqMrtVnR-mb00wdBaVKXiubj1PZlpxXyBQ/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="text-muted-foreground hover:text-foreground transition-colors"
          >
            お問い合わせ
          </a>
        </nav>
      </div>
    </footer>
  );
}
